import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-create_mch_code",
  "use": "icon-create_mch_code-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-create_mch_code\"><path d=\"M512 85.333333C276.48 85.333333 85.333333 276.48 85.333333 512s191.146667 426.666667 426.666667 426.666667 426.666667-191.146667 426.666667-426.666667S747.52 85.333333 512 85.333333z m213.333333 469.333334h-170.666666v170.666666h-85.333334v-170.666666H298.666667v-85.333334h170.666666V298.666667h85.333334v170.666666h170.666666v85.333334z\" p-id=\"1078\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol